<template>
  <div class="product" style="background:#fff">
    <div class="pro-head content flex-center">
      <div class="content-item content-item-pc content-item-mb flex-space-between">
        <div class="con-info">
          <p>案例展示介绍</p>
          <p>各个行业特定场景实现智能化运行</p>
        </div>
        <img class="con-img" src="../../assets/product_head.gif"/>
      </div>
    </div>
    <p class="app-title" style="padding:60px 0">
      案例展示
    </p>
    <div class="pro-content" style="position:relative">
      <div class="pro-cont-one">
        <div class="content-item flex-space-between">
          <div class="pro-con-info">
            <p>园区智能化</p>
            <p>园区项目基于三维可视化技术，呈现各个建筑设备的位置、运行状态的真实映象，辅助于设备的业务管理，
              包含设备维修记录、设备巡检记录、设备告警等信息，完整呈现设备整个生命周期管理。同时基于强大的物联网支撑平台，
              实现多设备报警及联动，最终实现整个场园区的数字化智能管理。</p>
          </div>
          <img class="pro-con-img" src="../../assets/example/fenghuangshan.jpg"/>
        </div>
      </div>
      <div class="pro-cont-two" style="">
        <div class="content-item flex-space-between"
             style="border-bottom: 1px solid rgba(255,255,255,0.5);">
          <img class="pro-con-img" alt src="../../assets/example/school1.jpg"/>
          <div class="pro-con-info ta">
            <p>智慧校园</p>
            <p>智慧校园充分运用IoT、云计算、大数据、人工智能等先进技术，以“智能化+数字化+生态化”为核心
              规划理念，打通产业链，完善服务链，丰富配套链，构建三链合一的智慧校园生态圈，实现校园、教学、生活等协同发展，互惠共赢。</p>
          </div>
        </div>
      </div>
      <div class="pro-cont-three" style="">
        <div class="content-item flex-space-between"
             style="border-bottom: 1px solid rgba(255,255,255,0.5);">
          <div class="pro-con-info">
            <p>智慧医院</p>
            <p>智慧医院业务平台通过为医院构建数据交互平台、数据中心及基于数据内容的扩展应用，在各应用系统间实现标准的信息共享和交换，消除医院信息系统信息孤岛，该平台整合了各项管理业务，
              通过实时监测能源消耗情况、安全状态和设备运行状况等关键数据，提供数据分析、预警提示和报表展示功能，帮助医院管理者深入了解后勤运行情况，
              优化资源利用，降低成本开支，确保医院后勤运行的高效、安全和可持续。同时，通过数字化管理，还能提高工作效率，简化流程，减少人力资源浪费，为医院的整体运行提供有力支持。</p>
          </div>
          <img class="pro-con-img" src="../../assets/example/hospital.jpg"/>
        </div>
      </div>
    </div>

    <p class="app-title widddd" style="padding:60px 0;">
      方案下载
    </p>
    <div class="pro-content  pro-advantage " style="display: flex;flex-wrap: wrap;">

        <div v-for="(item,index) in downfilelist" class="download"
            >
          <el-link target="_blank" :href.asyc="item.path" :underline="false">
            <span  >{{item.name}}</span>
          </el-link>
        </div>
    </div>
    <!--<div class="pro-content advantage-border pro-advantage">

      <div class="content-item advantage-item flex-center">
        <div class="pro-adv-info">
          <span>方案优势</span>
        </div>
        <img class="pro-adv-img" src="../../assets/advantage3.png"/>
      </div>
      <div class="content-item advantage-border advantage-item flex-center" style="border-bottom: 1px solid rgba(255,255,255,0.5);">
        <img class="pro-adv-img" src="../../assets/advantage2.png"/>
        <div class="pro-adv-info adv-ta">
          <span>实物图片</span>
        </div>
      </div>
      <div class="content-item advantage-border advantage-item flex-center" style="border-bottom: 1px solid rgba(255,255,255,0.5);">
        <div class="pro-adv-info">
          <span>技术架构</span>
        </div>
        <img class="pro-adv-img" src="../../assets/advantage1.png"/>
      </div>

    </div>-->
  </div>
</template>

<script>
  export default {
    name: "wk_product",
    data() {
      return {
        serverName: "http://www.meshwork.com.cn/downloads/",
        filelist:["智慧公园-案例分享.pdf",
          "智慧小区-案例分享.pdf",
          "智慧园区-整体解决方案 - V2.0.pdf",
          "智慧医院-整体解决方案.pdf",
          "智慧水务-三维可视化运维-智慧水务解决方案.pdf",
          "智慧建筑-升级改造规划方案 - V2.0.pdf",
          "智慧高校-智能化综合管理平台解决方案 - V1.0.pdf",
          "安全园区-可视化指挥调度管理平台解决方案.pdf",
          "智慧高铁站-建设方案 - V1.2.pdf"
        ],
        downfilelist:[]
      }
    },
    mounted(){
      this.init()
    },
    methods:{
      init(){
        this.filelist.map(item=>{
          this.downfilelist.push({
            name: item,
            path: this.serverName + item
          })
        })

      }
    }
  }
</script>

<style scoped>
  @import "../../style.css";
  @import "wk_community_pc.css";
  @import "wk_community_mini.css";
</style>



// WEBPACK FOOTER //
// src/components/wk_community/wk_community.vue